module.exports = __webpack_public_path__ + "static/img/actions.7c4a162c.svg";